import React, { useLayoutEffect, useRef } from 'react';

const mosaicInputBaseHeight = 40;

function autoGrowTextareaHeight(this: HTMLTextAreaElement) {
    const el = this;
    if (!el) return;
    if (!el.value.trim()) {
        el.style.height = mosaicInputBaseHeight + 'px';
        return;
    }

    // Reset to 'auto' before measuring, otherwise scrollHeight can never drop below the previously expanded height.
    const scrollTop = el.scrollTop;
    el.style.height = 'auto';
    const nextHeight = Math.max(el.scrollHeight, mosaicInputBaseHeight);
    const maxHeight = parseFloat(window.getComputedStyle(el).maxHeight);
    el.style.height = (Number.isFinite(maxHeight) ? Math.min(nextHeight, maxHeight) : nextHeight) + 'px';
    el.scrollTop = scrollTop;
};

export default function useTextareaMutations(element: React.RefObject<HTMLTextAreaElement>, deps?: React.DependencyList) {
    const lastEl = useRef<HTMLTextAreaElement>();
    useLayoutEffect(() => {
        const el = element.current;
        if (!el) return;

        const addListeners = lastEl.current !== el;
        lastEl.current = el;

        if (addListeners) {
            const events = ['keydown', 'keyup', 'blur', 'focusout', 'focus', 'mouseup', 'change', 'input', 'auto-resize'] as (keyof HTMLElementEventMap)[];

            events.forEach(event => {
                lastEl.current?.removeEventListener(event, autoGrowTextareaHeight);

                el.removeEventListener(event, autoGrowTextareaHeight);
                el.addEventListener(event, autoGrowTextareaHeight);
            });
        }
        autoGrowTextareaHeight.call(el);
        setTimeout(() => autoGrowTextareaHeight.call(el), 50); // Also after a small delay in case the content to capture re-renders
        // eslint-disable-next-line 
    }, [element, ...(deps || [])]);
}